module.exports = __webpack_public_path__ + "media/images/MyGolana-mobile-588512ef5a5b49915c77e8d6cb62eff5.png";